import { combineReducers } from 'redux';
import { userAccountReducer as account } from './account';
import { userIntegrationsReducer as integrations, UserIntegrationsState } from './integrations';
import { userMetadataReducer as metadata, UserMetadata } from './metadata';
import { userNotificationsReducer as notifications, UserNotificationsState } from './notifications';
import { userStatsReducer as stats } from './stats';
import UserStats from '@models/UserStats';
import { UserSession } from '@app/types';

export interface AppUser {
  account: UserSession;
  integrations: UserIntegrationsState;
  metadata: UserMetadata;
  notifications: UserNotificationsState;
  stats: UserStats;
}

const userReducer = combineReducers({
  account,
  integrations,
  metadata,
  notifications,
  stats,
});

export default userReducer;
